'use strict';
import viewport from '../lib/viewport';

$(document).ready(function () {
    var $navbar = $("#navbar");
    var $nav = $navbar.find(".nav");
    var $navItem = $nav.find(".dropdown-toggle");


    if(viewport.is('tablet') || viewport.is('mobile')) {
        $navItem.on('click',function (e) {
            e.preventDefault();
            $(this).parent().toggleClass("collapsed");
        });
    }
});


// WEBPACK FOOTER //
// ./app/Resources/assets/js/scripts/navbar.js